import React, { useState } from 'react';
import { styled } from 'styled-components';
import { AccordionData } from '@contracts';
import AccordionItem from './AccordionItem';

interface AccordionProps {
  items: AccordionData[];
  textColor?: string;
  dividerColor?: string;
  dividerIsSolid?: boolean;
  itemPadding?: string;
  contentPadding?: string;
  itemPaddingMobile?: string;
  contentPaddingMobile?: string;
  iconsSize?: string;
  iconsColor?: string;
  titleUppercase?: boolean;
  topDivider?: boolean;
  mobileTopDivider?: boolean;
  bottomDivider?: boolean;
  mobileBottomDivider?: boolean;
  isUsingArrows?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  items,
  textColor,
  itemPadding,
  contentPadding,
  titleUppercase,
  itemPaddingMobile,
  contentPaddingMobile,
  iconsSize,
  iconsColor,
  topDivider,
  mobileTopDivider,
  bottomDivider,
  mobileBottomDivider,
  dividerColor = '#FAEAD6',
  dividerIsSolid = true,
  isUsingArrows = false
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>();

  const handleSetSelectedIndex = (idx: number) => {
    const isAleadySelected = idx === selectedIndex;
    if (isAleadySelected) {
      setSelectedIndex(undefined);
    } else {
      setSelectedIndex(idx);
    }
  };

  return (
    <AccordionContainer>
      {items.map((item, index) => (
        <AccordionItem
          key={item.title}
          isSelected={selectedIndex === index}
          itemData={item}
          index={index}
          isFirst={index === 0}
          isLast={index === items.length - 1}
          dividerColor={dividerColor}
          dividerIsSolid={dividerIsSolid}
          textColor={textColor}
          titleUppercase={titleUppercase}
          itemPadding={itemPadding}
          contentPadding={contentPadding}
          itemPaddingMobile={itemPaddingMobile}
          contentPaddingMobile={contentPaddingMobile}
          iconsSize={iconsSize}
          iconsColor={iconsColor}
          topDivider={topDivider}
          mobileTopDivider={mobileTopDivider}
          bottomDivider={bottomDivider}
          mobileBottomDivider={mobileBottomDivider}
          setSelectedIndex={handleSetSelectedIndex}
          isUsingArrows={isUsingArrows}
        />
      ))}
    </AccordionContainer>
  );
};

export default Accordion;

const AccordionContainer = styled.dl<{ $topBorder?: boolean; $mobileTopBorder?: boolean }>`
  width: 100%;
  margin: 0;
`;
